<template>
  <BaseCard
    :heading="filters.capitalize($t('global.items.note'))"
    :info="$t('register.note_info')"
  >
    <Flex
      align="center"
      :gap="0.5"
    >
      <BaseIcon
        name="message-circle"
        size="s"
      />
      <BaseText v-test="'sale-note'">
        <span v-html="filters.formatEnters(note || '')"></span>
      </BaseText>
    </Flex>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import filters from '@/filters';

defineProps<{
  note: string;
}>();
</script>
